import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute, CanLoad, Route, NavigationEnd } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { UserService } from '../service/user.service';
import { environment } from '../../environments/environment-taxi-directo';
import { filter } from 'rxjs/operators';
import { DatosCompartidosService } from '../service/datos-compartidos.service';
declare var gtag;
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {
flagGa : boolean = true;
dataSubscription: Subscription;
data: any;
isWebAdmin = false;

  constructor(
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private _datosCompartidos: DatosCompartidosService) {
// if(this.flagGa == environment.VALIDACIONES_SOLICITAR.FLAG_GA){
//   const navEndEvents$ = this.router.events.
//   pipe(
//     filter(event => event instanceof NavigationEnd)
//   );
//   navEndEvents$.subscribe((event: NavigationEnd)=>{
//     gtag('config', 'UA-105824776-1',{
//         'page_path': event.urlAfterRedirects
//     });

//   })

// }
      this.dataSubscription = this._datosCompartidos.user$
      .subscribe(data => {
        this.data = data;
      });
     }



  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      let user: any = undefined;

      if(document.location.href.includes("admin")){
        user = JSON.parse(localStorage.getItem('activeUserWebAdmin'));
      }else if(document.location.href.includes("intranet")){
          user = JSON.parse(localStorage.getItem('activeUserIntranet'));
      }

      if (user != undefined) {
        this.router.navigate(['/default']);
        return false;
      } else {
        return true;
      }
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    return this.validarUsuario(state.url);
  }

  canLoad(route: Route) {
    const url = '/default/' + route.path;
    return this.validarUsuario(url);
  }

  validarUsuario(url: string): boolean {
    let user: any = undefined;

    if(document.location.href.includes("admin")){
      user = JSON.parse(localStorage.getItem('activeUserWebAdmin'));
    }else if(document.location.href.includes("intranet")){
        user = JSON.parse(localStorage.getItem('activeUserIntranet'));
    }
    
    let band = false;
    this.isWebAdmin = document.location.href.includes("admin");
    if (user != undefined) {

      switch (user.Rol) {

        case environment.ROL.ADMIN:

          if (url === '/default' || url === '/default/empresa' || url === '/default/solicitar-servicio' || url === '/default/metodo-pago' || url === '/default/reporte-aprobacion' || url == 'default/configuracion-parametros') {
            this.router.navigate(['/default/cuenta']);
            band = false;
          } else {
            band = true;
          }
          break;
        case environment.ROL.ADMIN_CORPORATIVO:
           
          if (url == 'default/configuracion-parametros' ) {
            this.router.navigate(['/default/cuenta']);

            band = false;
          } else {
            band = true;
          }

          break;

        case environment.ROL.CORPORATIVO:
          //url === '/default/reporte-empresarial' ||
          if (url === '/default/usuarios' || url === '/default/reporte-aprobacion' || url === 'default/sedes' 
          || url == 'default/configuracion-parametros' || url == '/default/monitoreo') {
            this.router.navigate(['/default']);
            band = false;
          } else {
            band = true;
          }
          break;
        case environment.ROL.PARTICULAR:
          if (url === '/default/empresa' || url === '/default/usuarios' || url === '/default/reporte-empresarial' || url === '/default/reporte-aprobacion' 
          || url === 'default/sedes' || url == 'default/configuracion-parametros' || url == '/default/monitoreo') {
            this.router.navigate(['/default']);
            band = true;
          } else {
            band = true;
          }
          break;
        case environment.ROL.ASISTENTE_CORPORATIVO:
          if (url === '/default/empresa' || url === '/default/usuarios' || url === '/default/reporte-empresarial' || url === '/default/reporte-aprobacion' 
          || url === 'default/sedes' || url == 'default/configuracion-parametros' || url == '/default/monitoreo') {
            this.router.navigate(['/default']);
            band = false;
          } else {
            band = true;
          }

          break;
        case environment.ROL.SUPERVISOR:
          //Permiso de Proaccion Empresarial para ver Usuarios
          if((user.IdEmpresa == 128 || user.IdEmpresa == 13361) && this.isWebAdmin){
            if (url === '/default' || url === '/default/solicitar-servicio' || url === '/default/envios') {
              this.router.navigate(['/default/cuenta']);
              band = false;
            } else {
              band = true;
            }
          }else{
            band = true;
          }
          // if(user.IdEmpresa == 128 || user.IdEmpresa == 13361){
          //   //Proaccion
          //   if (url === '/default/centro-costo' || url === '/default/sedes' || url == 'default/configuracion-parametros'
          //   || url == '/default/monitoreo') {
          //     this.router.navigate(['/default']);
          //     band = false;
          //   } else {
          //     band = true;
          //   }
          // }else{
          //   if (url === '/default/usuarios' || url === '/default/centro-costo' || url === 'default/sedes' || url == 'default/configuracion-parametros'
          //   || url == '/default/monitoreo') {
          //     this.router.navigate(['/default']);
          //     band = false;
          //   } else {
          //     band = true;
          //   }
          // }
          break;
        default:
          // this.router.navigate(['/default']);
          this.router.navigate(['/default/cuenta']);
          band = true;
          break;

        case environment.ROL.OWNER:
          if (url.indexOf('configuracion-parametros') == -1) {
            this.router.navigate(['/default/configuracion-parametros']);
            band = false;
          } else {
            band = true;
          }
          break;

      }

    } else {
      this.router.navigate(['/']);
    }
    return band;
  }
}
